import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-warranty-coverage',
  templateUrl: './warranty-coverage.component.html',
  styleUrls: ['./warranty-coverage.component.scss']
})
export class WarrantyCoverageComponent implements OnInit {

  @Input() items:any;

  constructor() { }

  ngOnInit(): void {
  }

}
